import './AccordionItem.css';

import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const AccordionItem = ({ isOpen, onToggle, title, children, id }) => {
  return (
    <div className="accordion-item">
      <button
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`content-${id}`}
        className="accordion-button"
      >
        <h3 className="accordion-title">{title}</h3>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className="accordion-icon"
        >
          <ChevronDown size={24} />
        </motion.div>
      </button>

      <motion.div
        id={`content-${id}`}
        aria-hidden={!isOpen}
        initial={false}
        animate={{
          height: isOpen ? 'auto' : 0,
          opacity: isOpen ? 1 : 0,
        }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        className="accordion-content-wrapper"
      >
        <div className="accordion-content">{children}</div>
      </motion.div>
    </div>
  );
};

export default AccordionItem;
